import { render } from "./ViewBonAncien.vue?vue&type=template&id=413c07f0&scoped=true&ts=true"
import script from "./ViewBonAncien.vue?vue&type=script&lang=ts"
export * from "./ViewBonAncien.vue?vue&type=script&lang=ts"

import "./ViewBonAncien.vue?vue&type=style&index=0&id=413c07f0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-413c07f0"]])

export default __exports__